import debug from 'debug';
import fetch from 'fetch-everywhere';

const log = debug('huddle:api:request');

const request = async (url, options) => {
  log('requesting...', { url, options });
  const response = await fetch(url, options);
  log('response', { url, response });
  log('content-length:', response.headers.get('content-length'));
  log('content-type:', response.headers.get('content-type'));

  // NOTE removed because obsfucating proper error messages from API
  // if (response.status >= 400) {
  //   throw new Error(`Response error: ${url} resulted in ${response.status}`);
  // }

  if (response.headers.has('content-length')
    && Number(response.headers.get('content-length')) <= 0) {
    return null;
  }

  const contentType = response.headers.get('content-type');

  return contentType.indexOf('application/json') > -1
    ? response.json()
    : response.text();
};

export default request;



// WEBPACK FOOTER //
// ./src/lib/api/request.js